export const quickActionMutationKeys = {
    all: ["quickActions"] as const,
    updateAppointmentsById: (id: string)=> [...quickActionMutationKeys.all, "appointments", id] as const,
} as const 
